module.exports = __webpack_public_path__ + "static/media/Meter.bda6c1bd.png";